import { FC } from 'react';

import './style.scss';

export const ArticleCardSkeleton: FC = () => {
  return (
    <div className="svg-skeleton article-card-skeleton">
      <svg width="342" height="230" viewBox="0 0 342 230" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect y="0.5" width="106" height="106" rx="4" fill="#E6E6E6" />
        <rect x="118" y="0.5" width="106" height="106" rx="4" fill="#E6E6E6" />
        <rect x="236" y="0.5" width="106" height="106" rx="4" fill="#E6E6E6" />
        <rect y="118.5" width="342" height="16" rx="4" fill="#E6E6E6" />
        <rect y="146.5" width="342" height="16" rx="4" fill="#E6E6E6" />
        <rect y="174.5" width="342" height="16" rx="4" fill="#E6E6E6" />
        <rect y="202.5" width="72" height="16" rx="4" fill="#E6E6E6" />
      </svg>
    </div>
  );
};
